import store from "./../store";

const DANGER = "sure-quote/alert/DANGER";
const WARN = "sure-quote/alert/WARN";
const SNACK = "sure-quote/alert/SNACK";
const SUCCESS = "sure-quote/alert/SUCCESS";

const defaultState = {
  errorWindow: {
    open: false,
    title: "",
    message: null,
    onClose: null
  },
  warningWindow: {
    open: false,
    title: "",
    message: null,
    showCancel: true,
    showConfirm: true,
    onCancel: null,
    onConfirm: null,
    confirmBtnText: "Ok",
    cancelBtnText: "Cancel"
  },
  successWindow: {
    open: false,
    title: "",
    showConfirm: true,
    onConfirm: null,
    confirmBtnText: "Ok"
  },
  snack: {
    open: false,
    color: "primary",
    message: ""
  }
};

const handleWarningAlert = (state, action) => {
  let open = action.props.open;

  if (action.props.cancelClicked) {
    if (state.warningWindow.onCancel) {
      state.warningWindow.onCancel();
    }
    open = false;
  }

  if (action.props.confirmClicked) {
    if (state.warningWindow.onConfirm) {
      state.warningWindow.onConfirm();
    }
    open = false;
  }

  return {
    ...state,
    warningWindow: {
      open: open,
      title: action.props.title,
      message: action.props.message,
      showCancel:
        action.props.showCancel !== undefined ? action.props.showCancel : false,
      showConfirm:
        action.props.showConfirm !== undefined
          ? action.props.showConfirm
          : true,
      onCancel: action.props.onCancel ? action.props.onCancel : null,
      onConfirm: action.props.onConfirm ? action.props.onConfirm : null,
      confirmBtnText:
        action.props.confirmBtnText !== undefined
          ? action.props.confirmBtnText
          : "Ok",
      cancelBtnText:
        action.props.cancelBtnText !== undefined
          ? action.props.cancelBtnText
          : "Cancel"
    }
  };
};

const handleSuccessAlert = (state, action) => {
  let open = action.props.open;

  if (action.props.confirmClicked) {
    if (state.successWindow.onConfirm) {
      state.successWindow.onConfirm();
    }
    open = false;
  }

  return {
    ...state,
    successWindow: {
      open: open,
      title: action.props.title,
      showConfirm:
        action.props.showConfirm !== undefined
          ? action.props.showConfirm
          : true,
      onConfirm: action.props.onConfirm ? action.props.onConfirm : null,
      confirmBtnText:
        action.props.confirmBtnText !== undefined
          ? action.props.confirmBtnText
          : "Ok"
    }
  };
};

const handleDangerAlert = (state, action) => {
  if (!action.props.open && state.errorWindow.onClose) {
    state.errorWindow.onClose();
  }

  return {
    ...state,
    errorWindow: {
      open: action.props.open,
      title: action.props.title,
      message: action.props.message,
      onClose: action.props.open ? action.props.onClose : null
    }
  };
};

const handleSnack = (state, action) => {
  let open = action.props.open;
  return {
    ...state,
    snack: {
      open: action.props.open,
      color: open ? action.props.color : state.snack.color,
      message: open ? action.props.message : state.snack.message
    }
  };
};

const NotificationReducer = (state = defaultState, action) => {
  switch (action.type) {
    case DANGER:
      return handleDangerAlert(state, action);
    case SUCCESS:
      return handleSuccessAlert(state, action);
    case SNACK:
      return handleSnack(state, action);
    case WARN:
      return handleWarningAlert(state, action);
    default:
      return state;
  }
};

export const alertDanger = props => ({
  type: DANGER,
  props
});

export const alertWarning = props => ({
  type: WARN,
  props
});

export const successWarning = props => ({
  type: SUCCESS,
  props
});

export const snack = props => {
  return {
    type: SNACK,
    props
  };
};

var timer;
export const showSnack = props => {
  if (props.open !== undefined) {
    store.dispatch(snack(props));
  } else {
    props.open = true;
    store.dispatch(snack(props));

    clearTimeout(timer);
    timer = setTimeout(function() {
      props.open = false;
      store.dispatch(snack(props));
    }, 10000);
  }

  return {
    type: null
  };
};

export default NotificationReducer;



// WEBPACK FOOTER //
// ./src/reducers/NotificationReducer.js